import React, { useState } from 'react';
import { TextField } from '@scale/scaleui';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';
import { isNil as _isNil, isEmpty as _isEmpty, isNaN as _isNaN } from 'lodash';

const NumberArrayInput: React.FC<{
  value: number[] | undefined;
  setValue: (value: number[] | undefined) => void;
  hint?: string;
}> = ({ value, setValue, hint }) => {
  const [displayValue, setDisplayValue] = useState<string>(_isNil(value) ? '' : String(value));
  const [typeError, setTypeError] = useState<boolean>(false);
  const handleChange = (value: string) => {
    if (_isEmpty(value)) {
      setValue(undefined);
      return;
    }
    let newValue;
    if (value.includes(',')) {
      newValue = value.split(',').map(v => Number(v.trim()));
    } else {
      newValue = [Number(value.trim())];
    }
    if (newValue.some(v => _isNaN(v))) {
      setTypeError(true);
      return;
    }
    setValue(newValue);
    setDisplayValue(String(newValue));
    setTypeError(false);
  };
  return (
    <div className="flex">
      <TextField
        value={displayValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayValue(e.target.value)}
        onBlur={() => handleChange(displayValue)}
        error={typeError}
      />
      {hint && <BuilderHint name="NumberArrayInput" hint={hint} />}
    </div>
  );
};

export default NumberArrayInput;
